import React, { useState } from 'react';

import { colors } from 'global/colors';
import { Wrapper, Container } from '../../components';
import { Header, HeadingContainer } from '../ChallengeListPage/styles';
import CurvedContainer from '../../components/CurvedContainer';
import Collapse from '../../../components/collapse';

import content from './data';

const PolicyPage = () => {
  const [data, setData] = useState(content);

  return (
    <Wrapper color="transparent">
      <CurvedContainer bottom height={110} color={colors.darkBlue} />
      <Container column>
        <HeadingContainer>
          <Header>Privacy Policy</Header>
        </HeadingContainer>

        {data.map((policy, i) => (
          <Collapse
            key={policy.id}
            title={policy.title}
            id={policy.id}
            isCollapsed={!policy.active}
            action={() => {
              let temp = [...data];
              temp[i]['active'] = !temp[i]['active'];
              setData(temp);
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: policy.data }} />
          </Collapse>
        ))}
      </Container>
    </Wrapper>
  );
};

export default PolicyPage;
